import script from "./CoeDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CoeDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./CoeDetailComponent.vue?vue&type=style&index=0&id=f61d04ce&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f61d04ce"]])

export default __exports__